<div class="row py-2">
  @for (option of optionsArray; track option; let i = $index) {
    <div class="col-md-4">
      <div
        class="form-check form-check-inline"
        [attr.aria-describedby]="errorId"
      >
        <label
          class="form-check-label"
          [for]="id + '_' + i"
        >
          {{ option.label }}
        </label>
        <input
          type="radio"
          class="form-check-input"
          [id]="id + '_' + i"
          [name]="field.name || id"
          [class.is-invalid]="showError"
          [value]="option.value"
          [formControl]="$any(formControl)"
          [formlyAttributes]="field"
        />
      </div>
    </div>
  }
</div>
